import React from 'react';
import Page from '../Page';

import data from './aboutus.json';

export default class Index extends Page {
  constructor(props) {
    super(props);
    this.state = {
      data,
    };
  }

  componentDidMount() {
    let element = document.querySelector('.loading');
    if (element) {
      element.style.display = 'none';
    }
  }

  render() {
    const { data } = this.state;
    return (
      <div
        className="container-privacy"
        style={{
          padding: '55px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <div
          className="center-doc mb-m"
          style={{
            maxWidth: '800px',
            textAlign: 'left',
          }}
        >
          <div>
            {data.map((item, index) => (
              <div key={index} style={{ marginBottom: '40px' }}>
                <h4
                  style={{
                    color: 'black',
                    marginBottom: '10px',
                  }}
                  dangerouslySetInnerHTML={{ __html: item.title }}
                />
                <h6
                  style={{
                    lineHeight: '1.7em',
                    maxWidth: '700px',
                    marginBottom: '20px',
                  }}
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
                {item.subContentHeader.length > 0 ? (
                  <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                    {item.subContentHeader.map((subItem, subIndex) => (
                      <li
                        key={subIndex}
                        style={{
                          listStyleType: 'disc',
                          marginBottom: '10px',
                          marginLeft: '20px', // Menambahkan indentasi untuk disk
                        }}
                      >
                        <h6
                          dangerouslySetInnerHTML={{ __html: subItem.title }}
                        />
                        <h6
                          style={{
                            lineHeight: '1.6em',
                            maxWidth: '700px',
                            marginTop: '5px',
                          }}
                          dangerouslySetInnerHTML={{
                            __html: subItem.description,
                          }}
                        />
                      </li>
                    ))}
                  </ul>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/About/Index.js